module.exports = __webpack_public_path__ + "media/images/sandbox/kachel_briefbogen-fcb127d83595d337c8a8a481c2884b20.jpg";